/**
 * Converts kebab-case strings to human-readable title case
 *
 * @param kebabCase - String in kebab-case format (e.g., "haiku-generator")
 * @returns Title case string (e.g., "Haiku Generator")
 *
 * @example
 * formatWorkflowName("haiku-generator") // "Haiku Generator"
 * formatWorkflowName("web-scraping-workflow") // "Web Scraping Workflow"
 * formatWorkflowName("simple-task") // "Simple Task"
 */
export function formatWorkflowName(kebabCase: string): string {
  if (!kebabCase) return 'Untitled'

  return kebabCase
    .split(/[-_]/) // Made it so that it also splits on underscores to make it work with legacy names
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
